import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsZendeskComponent } from './simple-icons-zendesk.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsZendeskComponent ],
    exports:      [ SimpleIconsZendeskComponent ],
    bootstrap:    []
})
export class SimpleIconsZendeskModule {}
